<div [ngClass]="certifClass" *ngIf="prop.certified">
  <div>
    <mat-icon class="small-icon" [appTooltip]="tooltip" color="accent">{{ icon }}</mat-icon>
  </div>
  <div *ngIf="widthDate" class="certif-date">{{ prop.certificationDate | date: 'yyyy' }}</div>
</div>